import cz from "./cz";
import de from "./de";
import en from "./en";
import es from "./es";
import el from "./el";
import fr from "./fr";
import it from "./it";
import ln from "./ln";
import nl from "./nl";
import pl from "./pl";
import pt from "./pt";
import hu from "./hu";
import ja from "./ja";

export default { de, en, es, el, fr, it, pl, pt, cz, ln, nl, hu, ja };



// WEBPACK FOOTER //
// ./src/resources/strings.js